import { render, staticRenderFns } from "./Mfr.vue?vue&type=template&id=e53b613a&"
import script from "./Mfr.vue?vue&type=script&lang=ts&"
export * from "./Mfr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports